import { useState } from 'react';
import { supabase } from '../lib/supabase';

export const useStorage = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadIdentificacion = async (file: File, userId: string): Promise<{ success: boolean; url?: string; error?: string }> => {
    try {
      setUploading(true);
      setUploadProgress(0);

      // Validar tipo de archivo
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        return { 
          success: false, 
          error: 'Solo se permiten archivos JPG, PNG o PDF' 
        };
      }

      // Validar tamaño (máximo 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB en bytes
      if (file.size > maxSize) {
        return { 
          success: false, 
          error: 'El archivo no puede superar los 5MB' 
        };
      }

      // Generar nombre único para el archivo
      const fileExt = file.name.split('.').pop();
      const fileName = `${userId}_${Date.now()}.${fileExt}`;
      const filePath = `${userId}/${fileName}`;

      setUploadProgress(50);

      // Subir archivo al bucket 'verificaciones'
      const { error: uploadError } = await supabase.storage
        .from('verificaciones')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (uploadError) {
        throw uploadError;
      }

      setUploadProgress(75);

      // Obtener URL pública del archivo
      const { data: urlData } = supabase.storage
        .from('verificaciones')
        .getPublicUrl(filePath);

      setUploadProgress(100);

      return { 
        success: true, 
        url: urlData.publicUrl 
      };
    } catch (error: any) {
      console.error('Error al subir identificación:', error);
      return { 
        success: false, 
        error: error.message || 'Error al subir el archivo' 
      };
    } finally {
      setUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    }
  };

  const deleteIdentificacion = async (url: string): Promise<{ success: boolean; error?: string }> => {
    try {
      // Extraer el path del archivo desde la URL
      const urlParts = url.split('/verificaciones/');
      if (urlParts.length < 2) {
        return { success: false, error: 'URL inválida' };
      }

      const filePath = urlParts[1];

      const { error } = await supabase.storage
        .from('verificaciones')
        .remove([filePath]);

      if (error) throw error;

      return { success: true };
    } catch (error: any) {
      console.error('Error al eliminar identificación:', error);
      return { 
        success: false, 
        error: error.message || 'Error al eliminar el archivo' 
      };
    }
  };

  return {
    uploading,
    uploadProgress,
    uploadIdentificacion,
    deleteIdentificacion,
  };
};